import { createGlobalStyle } from 'styled-components'
// eslint-disable-next-line import/no-unresolved
import { PancakeTheme } from '@thenexlabs/uikit/dist/theme'

declare module 'styled-components' {
  /* eslint-disable @typescript-eslint/no-empty-interface */
  export interface DefaultTheme extends PancakeTheme {}
}

const GlobalStyle = createGlobalStyle`
  * {
    font-family: 'Jetbrains Mono';
  }
  body {
    background-color: ${({ theme }) => theme.colors.backgroundAlt};

    img {
      height: auto;
      max-width: 100%;
    }
  }
`

export default GlobalStyle
